import React, { createContext, ReactNode, useContext, useState } from 'react'
import { APP_MODES, AppMode } from 'lib/mode/mode'

export const AppModeContext = createContext<AppModeContextType | undefined>(
  undefined
)

interface AppModeProviderProps {
  children: ReactNode
  initialMode?: AppMode
}

export const AppModeProvider: React.FC<AppModeProviderProps> = ({
  children,
  initialMode = APP_MODES.STANDALONE,
}) => {
  const [mode, setMode] = useState<AppMode>(initialMode)
  // @ts-ignore
  if (!window.__mode) {
    // @ts-ignore
    window.__mode = initialMode
  }

  const changeMode = (newMode: AppMode): void => {
    if (Object.values(APP_MODES).includes(newMode)) {
      setMode(newMode)
      // @ts-ignore
      window.__mode = newMode
    } else {
      // eslint-disable-next-line no-console
      console.error(
        `Invalid app mode: ${newMode}. Must be one of ${Object.values(APP_MODES).join(', ')}`
      )
    }
  }

  const isStandalone = mode === APP_MODES.STANDALONE
  const isUnity = mode === APP_MODES.UNITY

  const value: AppModeContextType = {
    mode,
    setMode: changeMode,
    isStandalone,
    isUnity,
  }

  return (
    <AppModeContext.Provider value={value}>{children}</AppModeContext.Provider>
  )
}

export const useAppMode = (): AppModeContextType => {
  const context = useContext(AppModeContext)
  if (context === undefined)
    throw new Error('useAppMode must be used within an AppModeProvider')
  return context
}

interface AppModeContextType {
  mode: AppMode
  setMode: (mode: AppMode) => void
  isStandalone: boolean
  isUnity: boolean
}
